"use strict";

exports.__esModule = true;
exports.DataItemChartThumbnail = DataItemChartThumbnail;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for DataItemChartWidget.
 */
function DataItemChartThumbnail(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    x: x,
    y: y
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    fill: "#ffffff"
  }), generateLines(Object.assign({}, props, {
    x: x,
    y: y
  })));
}
function generateLines(_ref) {
  var x = _ref.x,
    y = _ref.y,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#e0fbec" : _ref$color,
    width = _ref.width,
    height = _ref.height;
  var currentX = x + 2;
  var barWidth = 3;
  var totalPoints = Math.ceil((width - 4) / (barWidth + 2));
  var points = [];
  for (var i = 0; i < totalPoints; i++) {
    var barHeight = (height - 4) * Math.random();
    var currentY = y + height - barHeight;
    points.push(currentX + "," + currentY);
    currentX += barWidth + 2;
  }
  return /*#__PURE__*/_react["default"].createElement("polyline", {
    fill: color,
    stroke: color,
    strokeWidth: 1,
    points: points.join(" ")
  });
}